export default __webpack_public_path__ + "static/media/addService.92e9be1f.jpg";